/**
 * Formats an address object into a simple string, without line breaks.
 *
 * NOTE: This filter is not globally available in Vue. You must import it where needed.
 *
 * @param {Address} address
 *
 * @returns {string}
 */
export const addressFilter = (address) => {
    if (!address || typeof address !== 'object') {
        return '';
    }

    if (address.formattedAddress) {
        return address.formattedAddress;
    }

    return address.house + ' '
        + address.street + ' '
        + address.town + ' '
        + address.postcode;
};
